// extracted by mini-css-extract-plugin
export var avatar = "_n6-3";
export var avatarContainer = "_n6-2";
export var avatarSpacer = "_n6-5";
export var avatarSpacerContainer = "_n6-4";
export var avatarStackContainer = "_n6-1";
export var bubble = "_n6-0";
export var remainderBubble = "_n6-6";